import React from 'react';
import ReactDOM from 'react-dom';
import Page from 'Common/Page/';
import CodeBlock from 'Common/CodeBlock';

import Navigation from './index';

class App extends React.Component {
  render() {
    return (
      <Page title='Navigation' breakContainer>
        <Navigation
          active='endorsements'
          background='#fff'
          edge='#f8f8f8'
          gradient='rgba(0, 0, 0, 0)'
        />
        <CodeBlock
          value={`import { Navigation } from '@politico/interactive-style-elections';

<Navigation
  active='endorsements'
  background='#fff'
  edge='#f8f8f8'
  gradient='rgba(0, 0, 0, 0)'
/>

/*
 * Note: "edge" should be slightly darker than your
 * background, with "gradient" being a fully transparent.
 */
        `}
        />
      </Page>
    );
  }
}

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
